import { useNavigation } from 'expo-router'
import { useEffect } from 'react'
import { BackHandler, Platform } from 'react-native'

/** @see {@link https://github.com/react-navigation/react-navigation/issues/10394#issuecomment-1525696476} */
export function useDisableSwipingBackToThePreviousPage() {
  const navigation = useNavigation()

  useEffect(() => {
    const parentNavigation = navigation.getParent()
    const grandparentNavigation = parentNavigation?.getParent()
    const greatGrandparentNavigation = grandparentNavigation?.getParent()

    // Disable swipe gestures (iOS only)
    navigation.setOptions({ gestureEnabled: false })
    parentNavigation?.setOptions({ gestureEnabled: false })
    grandparentNavigation?.setOptions({ gestureEnabled: false })
    greatGrandparentNavigation?.setOptions({ gestureEnabled: false })

    // Handle Android hardware back button
    const handleBackPress = () => true // Returning true prevents back action

    const subscription =
      Platform.OS === 'android'
        ? BackHandler.addEventListener('hardwareBackPress', handleBackPress)
        : undefined

    return () => {
      // Re-enable swipe gestures when component unmounts
      navigation.setOptions({ gestureEnabled: true })
      parentNavigation?.setOptions({ gestureEnabled: true })
      grandparentNavigation?.setOptions({ gestureEnabled: true })
      greatGrandparentNavigation?.setOptions({ gestureEnabled: true })
      subscription?.remove()
    }
  }, [navigation])
}
